import axios from 'axios'
import {initVideoPlayer} from "./videoPlayer.js";

document.querySelectorAll('[data-search]').forEach(search => {


  const language = search.getAttribute('data-language')
  let cancelToken = null

  const input = search.querySelector('input')

  const resultWrappers = {
    pages: search.querySelector('[data-results-pages-wrapper]'),
    apprentices: search.querySelector('[data-results-apprentices-wrapper]'),
    resources: search.querySelector('[data-results-resources-wrapper]')
  }
  const results = {
    pages: search.querySelector('[data-results-pages]'),
    apprentices: search.querySelector('[data-results-apprentices]'),
    resources: search.querySelector('[data-results-resources]')
  }

  const initWrapper = (wrapper) => {
    wrapper.querySelector('.search-results-load-more')?.addEventListener('click', () => {
      wrapper.classList.remove('more-than-three')
    })
  }

  Object.values(resultWrappers).forEach(wrapper => initWrapper(wrapper))

  const updateWrapper = (wrapper, count) => {
    console.log('updateWrapper', wrapper, count)
    if (count > 0) {
      wrapper.classList.remove('no-results')
      if (count > 3) {
        wrapper.classList.add('more-than-three')
      }
    } else {
      wrapper.classList.add('no-results')
      wrapper.classList.remove('more-than-three')
    }
  }


  const doSearch = async () => {
    if (cancelToken) {
      cancelToken.cancel()
    }

    const value = input.value.toLowerCase()
    cancelToken = axios.CancelToken.source();

    if (value.length < 3) {
      return clear()
    }

    try {
      const response = await axios.get(window.php_vars.restUrl + 'glunz/v1/search-results', {
        cancelToken: cancelToken.token,
        params: {
          query: value,
          language
        }
      })

      update(response.data, value)

    } catch (e) {
      console.error(e)
    }
  }

  const clear = () => {
    results.pages.innerHTML = ''
    results.apprentices.innerHTML = ''
    results.resources.innerHTML = ''

    resultWrappers.pages.classList.add('no-results')
    resultWrappers.apprentices.classList.add('no-results')
    resultWrappers.resources.classList.add('no-results')
  }


  const clearResults = () => {
    results.pages.innerHTML = ''
    results.apprentices.innerHTML = ''
    results.resources.innerHTML = ''

    resultWrappers.pages.classList.add('no-results')
    resultWrappers.apprentices.classList.add('no-results')
    resultWrappers.resources.classList.add('no-results')
  }


  const update = (data, value) => {
    clearResults()

    const resultCount = {
      pages: 0,
      apprentices: 0,
      resources: 0
    }

    data.posts.forEach(post => {

      // WRAPPER
      const result = document.createElement('div')
      result.classList.add('search-result')

      result.innerHTML = post.teaser;

      switch (post.type) {
        case 'apprenticeship':
          results.apprentices.appendChild(result)
          resultCount.apprentices++
          break
        case 'resource':
          const video = result.querySelector('[data-video]')
          if (video) {
            initVideoPlayer(video)
          }
          results.resources.appendChild(result)
          resultCount.resources++
          break
        default:
          results.pages.appendChild(result)
          resultCount.pages++
          break
      }
    })


    updateWrapper(resultWrappers.pages, resultCount.pages)
    updateWrapper(resultWrappers.apprentices, resultCount.apprentices)
    updateWrapper(resultWrappers.resources, resultCount.resources)
  }


  const handleSearch = async e => {
    e.preventDefault()
    await doSearch()
  }

  search.addEventListener('submit', handleSearch)
  input.addEventListener('keyup', handleSearch)

  clear()
})

